exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-5e03895f] .el-dialog__body{max-height:580px;overflow:auto}\n", ""]);

// exports
